import { ContentContainer } from '@atlassian/amkt-common';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

const initialState = {
  asyncProps: undefined,
  err: false,
};

export default class AsyncPropsLoader extends Component {
  static propTypes = {
    component: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
    syncProps: PropTypes.object,
    resolveAsyncProps: PropTypes.func.isRequired,
  };

  static defaultProps = {
    errorMessage: "Looks like we weren't able to resolve some data",
    syncProps: {},
  };

  state = initialState;

  UNSAFE_componentWillMount() {
    this.resolveAsyncProps(this.props);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (this.props.resolveAsyncProps !== newProps.resolveAsyncProps) {
      this.setState(initialState);
      this.resolveAsyncProps(newProps);
    }
  }

  resolveAsyncProps(props) {
    props.resolveAsyncProps().then(
      ap => {
        this.setState({ asyncProps: ap });
      },
      error => {
        console.error(error);
        this.setState({ err: true });
      }
    );
  }

  render() {
    const ComponentPassed = this.props.component;
    return (
      <ContentContainer
        completeSpinImmediately={true}
        dataError={this.state.err}
        dataErrorMessages={Immutable.List([Immutable.Map({ message: this.props.errorMessage })])}
        loading={!this.state.err && !this.state.asyncProps}
        optimisticLoadTime={200}
      >
        {this.state.asyncProps ? (
          <ComponentPassed {...this.props.syncProps} {...this.state.asyncProps} />
        ) : (
          undefined
        )}
      </ContentContainer>
    );
  }
}
